import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-68" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-69" data-mp="4lqj4w64bd3i">
        

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif",
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-70" data-mp="12a0j75mcfqrz">
          RECOVER FROM ANY MUSCLE INJURY SAFELY AND PROGRESSIVELY
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "14px",
        paddingBottom: "20px"
      }} data-id="element-71" data-mp="nb6njukxbpp7">
          Complete muscle recovery in 60 minutes using a clinical method
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-72" data-mp="3j8iv8twpu6s2">
          <img src="https://cdn.magicpatterns.com/uploads/pSsi9cjFFUc4pFqn7dTEzD/CHECKOUT_WEBP.webp" alt="The 360° Muscle Recovery System™ — 6-volume digital book plus 5 bonuses in digital format" width={1536} height={1024} sizes="(min-width: 640px) 672px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-contain" data-id="element-73" data-mp="39cpboqkkxd0s" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-74" data-mp="2violwmblv0ck">
          ⭐ 4.9 · Join 500+ satisfied professionals and individuals recovering from muscle strains · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-75" data-mp="nb1imyt8vhts">
          <CTAButton href="#value" data-id="element-76" data-mp="n9i35afexat2">See the 360 system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-77" data-mp="icrsj2mdn7f1">
            COMPLETE MUSCLE RECOVERY COMBO 2026. The #1 system for physical education teachers,
            personal trainers, kinesiologists and individuals with muscle injuries who need a real,
            progressive and ready-to-use recovery protocol.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-78" data-mp="1126nqgfdt2bi">
            Hamstrings · Lower Back · Calves · Shoulders · Groin · Quads
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-79" data-mp="3htga4a18inje">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-80" data-mp="21a4srt66ce4x">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-81" data-mp="2b0fvjce4gha8" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-82" data-mp="2g0lrv5vc6ryn">
            6 Volumes + 5 bonuses · 150+ pages - Everything you need in one place.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-83" data-mp="2p0h5dhcd6z1u">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-84" data-mp="umhdeaf58hnt">
              <Icon className="h-4 w-4 text-grape" data-id="element-85" data-mp="uokcrl26rn57" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-86" data-mp="znn98h43ol1k">
          🔥 Limited-time offer · Then the price goes back up to $38
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-87" data-mp="3hqjzsebhkq7q">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-88" data-mp="3cp33yx7uzty0" />
          22 people are watching this product right now
        </p>
      </div>
    </header>;
}